import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Img from "gatsby-image"
import "../styles/pages/gallery/lightbox.scss"
import close from "../images/icons/close.png"
import left from "../images/icons/prev.png"
import right from "../images/icons/next.png"

class Lightbox extends Component {
  state = {
    showLightbox: false,
    selectedImage: 0,
  }

  componentDidMount = () => {
    window.addEventListener("keyup", this.handleKeyUp, false)
  }

  componentWillUnmount = () => {
    window.removeEventListener("keyup", this.handleKeyUp, false)
  }

  handleClick = (e, index) => {
    console.log("click")
    e.preventDefault()
    this.setState({
      showLightbox: !this.state.showLightbox,
      selectedImage: index,
    })
  }

  closeModal = () => {
    this.setState({ showLightbox: false })
  }

  goBack = () => {
    this.setState({ selectedImage: this.state.selectedImage - 1 })
  }

  goForward = () => {
    this.setState({ selectedImage: this.state.selectedImage + 1 })
  }

  handleKeyUp = e => {
    e.preventDefault()
    const { keyCode } = e
    if (this.state.showLightbox) {
      if (keyCode === 37) {
        // Left Arrow Key
        if (this.state.selectedImage > 0) {
          this.setState({ selectedImage: this.state.selectedImage - 1 })
        }
      }
      if (keyCode === 39) {
        // Right Arrow Key
        if (this.state.selectedImage < this.props.images.length - 1) {
          this.setState({ selectedImage: this.state.selectedImage + 1 })
        }
      }
      if (keyCode === 27) {
        // Escape key
        this.setState({ showLightbox: false })
      }
    }
  }

  render() {
    const { images } = this.props

    const { showLightbox, selectedImage } = this.state
    return (
      <section className="gallery-wrap">
        <div id="gallery" className="gallery">
          {images.map((img, i) => (
            <div
              className="galleryItem"
              key={img.node.childImageSharp.sizes.src}
            >
              <a
                href={img.node.childImageSharp.sizes.src}
                alt="Dorlands Image"
                onClick={e => this.handleClick(e, i)}
              >
                <Img sizes={img.node.childImageSharp.sizes} />
              </a>
            </div>
          ))}
        </div>

        <LightboxModal
          visible={showLightbox}
          onKeyUp={e => this.handleKeyDown(e)}
        >
          <div id="lightboxContent" className="lightboxContent">
            <Img
              className="lightboxImg"
              sizes={images[selectedImage].node.childImageSharp.sizes}
            />
            <Controls>
              <button className="button" onClick={this.closeModal}>
                <img className="close" src={close} alt="close window icon" />
              </button>
              <LeftRight>
                <button
                  className="button"
                  onClick={this.goBack}
                  disabled={selectedImage === 0}
                >
                  <img className="left" src={left} alt="left icon" />
                </button>
                <button
                  className="button"
                  onClick={this.goForward}
                  disabled={selectedImage === images.length - 1}
                >
                  <img className="right" src={right} alt="right icon" />
                </button>
              </LeftRight>
            </Controls>
          </div>
        </LightboxModal>
      </section>
    )
  }
}

const LightboxModal = styled.div`
  z-index: 21;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  opacity: ${props => (props.visible ? "1" : "0")};
  visibility: ${props => (props.visible ? "visible" : "hidden")};
`
const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 10px 4px 8px;
  padding: 2px;
`
const LeftRight = styled.div`
  button:first-child {
    margin-right: 10px;
  }
`

Lightbox.propTypes = {
  images: PropTypes.array.isRequired,
}

export default Lightbox
